import { render, staticRenderFns } from "./ProductPoster.vue?vue&type=template&id=2b4b9758&scoped=true"
import script from "./ProductPoster.vue?vue&type=script&lang=ts"
export * from "./ProductPoster.vue?vue&type=script&lang=ts"
import style0 from "./ProductPoster.vue?vue&type=style&index=0&id=2b4b9758&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b9758",
  null
  
)

export default component.exports